/**
 * Created by Michał Stawski on 2018-06-13.
 */
import React from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  withStyles
} from '@material-ui/core'
import { connect } from 'react-redux'
import { Field, FieldArray, initialize, reduxForm, SubmissionError } from 'redux-form'
import { Select, TextField } from 'redux-form-material-ui-adapter'
import { CLIENT_ACTION_SUCCESS } from 'redux-coreapi'
import { numericality, required } from 'redux-form-validators'
import { cleanValues } from 'reducers/schema'
import { clientAction } from '../../reducers/restApi'
import MenuItem from '@material-ui/core/MenuItem'
import { genericOptions } from '../../reducers/restApiSelectors'
import SelectMultipleReduxField from '../MutplieReduxSelect'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import PotentialAddDialog from './PotentialAddDialog'
import EventAddDialog from './EventAddDialog'
import Typography from '@material-ui/core/Typography'

// TODO move to one file
const req = required()
const num = numericality({ int: true, '>': 0 })

const styles = theme => ({
  formLabel: {
    margin: '8px 4px',
  },
  formButton: {
    margin: '8px 4px',
  }
})

const fields = [
  {
    name: 'event', component: Select, label: 'Event', validate: [req],
    childrenGenerator: props => props.eventOptions.map(
      ({ name, value }) => <MenuItem key={value} value={value}>{name}</MenuItem>)
  },
  { name: 'name', component: TextField, label: 'Nickname', validate: [req] },
  { name: 'age', component: TextField, label: 'Age', validate: [req, num] },
  {
    name: 'description', component: TextField, label: 'Description', validate: [req],
    props: { multiline: true }
  },
  //potentials
  //persons

]

const renderPersons = ({ fields, meta: { error, submitFailed }, classes }) => (

  <div>
    <Typography variant="h5">
      Persons
    </Typography>

    <Button variant='outlined' color="primary" aria-label="add"
            className={classes.formButton}
            fullWidth
            onClick={() => fields.push({})}
    >
      <AddIcon/> Add Person
    </Button>
    <Typography variant="caption">
      {submitFailed && error && <span>{error}</span>}
    </Typography>
    <div>
      {fields.map((member, index) => (
        <div key={index}>
          <Typography variant='h6' className={classes.formLabel}>

            Person #{index + 1}
            <Button variant='outlined' color="primary" aria-label="add"
                    onClick={() => fields.remove(index)}
                    className={classes.formButton}
            >
              <RemoveIcon/>
            </Button>
          </Typography>
          <Field
            name={`${member}.name`}
            type="text"
            component={TextField}
            label="Name"
            validate={[req]}
            fullWidth
          />
          <Field
            name={`${member}.description`}
            type="text"
            component={TextField}
            label="Description"
            multiline={true}
            validate={[req]}
            fullWidth
          />
        </div>
      ))}
    </div>
  </div>
)

class StoryAddDialog extends React.Component {
  state = {
    open: false,
    id: null,
    potentialDialogOpen: false,
    eventDialogOpen: false,
  }

  componentDidMount () {
    this.props.initializeForm({})
  }

  handleAddPotential () {
    this.setState({ potentialDialogOpen: true })
  }

  handleClosePotential () {
    this.setState({ potentialDialogOpen: false })
  }

  handleAddEvent () {
    this.setState({ eventDialogOpen: true })
  }

  handleCloseEvent () {
    this.setState({ eventDialogOpen: false })
  }

  render () {
    let {
      // objects,
      schema,
      handleSubmit,
      invalid, submitting,
      classes
      // ...props
    } = this.props
    // let item = {}

    // if (selectedId && this.props.open) {
    //   item = objects.data[selectedId].instance
    // }
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.props.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            Add Your Story
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
            </DialogContentText>
            <form>
              {fields.map(field =>
                <FormControl fullWidth key={field.name}>
                  {field.component === Select ?
                    <InputLabel>{field.label}</InputLabel> : ''
                  }
                  <Field margin="dense" fullWidth
                         key={field.name}
                         component={field.component}
                         name={field.name}
                         label={field.label}
                         validate={field.validate}
                         {...field.props}
                  >
                    {schema && field.childrenGenerator ? field.childrenGenerator(this.props) : field.children}
                  </Field>

                  {field.name === 'event' &&
                  <Button variant='outlined' color="primary" aria-label="add"
                          onClick={() => this.handleAddEvent()}
                          className={classes.formButton}
                  >
                    <AddIcon/> Add Event
                  </Button>
                  }
                </FormControl>)}
              <SelectMultipleReduxField
                options={this.props.potentialOptions}
                label="Potentials/Burdens"
                name="potentials"
                fullWidth
                // validate={[required()]}
              />
              <Button variant='outlined' color="primary" aria-label="add"
                      fullWidth
                      onClick={() => this.handleAddPotential()}
                      className={classes.formButton}
              >
                <AddIcon/> Add Potential
              </Button>
              <div>
                <FieldArray name="persons" component={renderPersons} classes={classes}/>
              </div>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleClose} color="primary">
              Cancel
            </Button>
            <Button
              disabled={invalid || submitting}
              color="primary" variant="contained"
              onClick={handleSubmit}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
        <PotentialAddDialog open={this.state.potentialDialogOpen} handleClose={() => this.handleClosePotential()}/>
        <EventAddDialog open={this.state.eventDialogOpen} handleClose={() => this.handleCloseEvent()}/>
      </div>
    )
  }
}

const onSubmit = (values, dispatch, props) => {
  dispatch((dispatch, getState) => {
    let sub
    values = { ...values }
    let state = getState()

    try {
      let objectType = 'treeStory'
      // values.persons = []
      // values.potentials = [1]
      if (values && values.id) {
        cleanValues(values, state, objectType, 'update')
        console.log('why are You here')
        sub = dispatch(clientAction([objectType, 'update'], values))
      } else {
        cleanValues(values, state, objectType, 'create')
        sub = dispatch(clientAction([objectType, 'create'], values))
      }

      if (sub.type) {
        console.error(sub)
      } else {
        sub.then(
          success => {
            if (success.type === CLIENT_ACTION_SUCCESS) {
              props.handleClose()
            } else {
              // dispatch(openSnackbar({message: 'Save Problem', autoHideDuration: 5000}));
              throw new SubmissionError('Save Problem')
            }
          }
        )
      }
    } catch (e) {
      console.error(e)
      throw new SubmissionError(e.validationErrors)
    }
  })
}

export default connect(
  (state) => {
    return {
      objects: state.restApi.treeStory,
      eventOptions: genericOptions('treeEvent', 'name')(state),
      potentialOptions: genericOptions('treePotential', 'name')(state),

      schema: state.schema.schema,
    }
  },
  (dispatch) => ({
    dispatch: dispatch,
    initializeForm:
      (initialValues) => dispatch(initialize('storyAddForm', initialValues)),
  })
)(reduxForm({
  /** @namespace state.form.storyAddForm **/
  form: 'storyAddForm',
  enableReinitialize: false,
  onSubmit
})(withStyles(styles)(StoryAddDialog)))
